<template>
  <button class="burger" @click="handleClick">
    <span />
    <span />
    <span />
  </button>
</template>

<script>
export default {
  props: {
    propsHandleClick: {
      type: Function,
      default: null,
    },
  },

  methods: {
    handleClick(value) {
      if (this.propsHandleClick) this.propsHandleClick(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.burger {
  position: relative;
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 0;
  padding: 0;

  span {
    display: block;
    width: 2rem;
    height: 0.2rem;
    background: $black;
    margin-bottom: 0.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
